<template>
    <div>
        <div style="padding-top:50px;">
            <div class="container">
                <div class="icon-block second applyContainer">
                    <h2 class="center blue-text">
                        <i class="large material-icons ">person_pin</i>
                    </h2>
                    <h3 class="center">{{$t("Sponsor.title")}}</h3>
                    <!--<p class="light">-->
                    <div style="margin-top:40px; ">
                        <p style="font-weight: 700;font-size: x-large">————————————————————————————</p>
                        <div style="display: inline-block;text-align: center;">
                            <h5 style="background-color: black;color: white;padding: 20px 20px;">Co-Host Sponsor</h5>
                        </div>
                        <br>
                        <a href="https://cobinhood.com/">
                            <img class="responsive-img" src="../../static/img/co-host-cobinhood.png">
                        </a>
                        <p style="font-weight: 700;font-size: x-large">————————————————————————————</p>
                        <div style="display: inline-block;text-align: center;">
                            <h5 style="background-color: black;color: white;padding: 20px 20px;">Platinum Sponsor</h5>
                        </div>
                        <br>
                        <a href="https://www.privateinternetaccess.com/">
                            <img class="responsive-img" src="../../static/img/PIA-sponsor-logo.jpg">
                        </a>
                        <p style="font-weight: 700;font-size: x-large">————————————————————————————</p>
                        <div style="display: inline-block;text-align: center;">
                            <h5 style="background-color: black;color: white;padding: 20px 20px;">Bronze Sponsor</h5>
                        </div>
                        <br>
                        <a href="https://www.seafile.com/home/">
                            <img class="responsive-img" src="../../static/img/seafile-logo.png">
                        </a>
                        <br>
                        <a href="https://www.microsoft.com/zh-tw/">
                            <img class="responsive-img" src="../../static/img/Microsoft-sponsor.png">
                        </a>
                        <p style="font-weight: 700;font-size: x-large">————————————————————————————</p>

                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "registration"
};
</script>
<style scoped>
.alert {
    position: relative;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
}

.alert-info {
    color: #0c5460;
    background-color: #d1ecf1;
    border-color: #bee5eb;
}
.alert-info hr {
    border-top-color: #abdde5;
}
.alert-info .alert-link {
    color: #062c33;
}
img {
    width: 30%;
    height: auto;
}
</style>





// WEBPACK FOOTER //
// src/components/sponsor.vue